export default "__VITE_ASSET__hx2Ee0CK__"